var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCanvasPlan(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37.821,
    height: 21.503,
    viewBox: "0 0 37.821 21.503",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1132",
    "data-name": "Group 1132",
    transform: "translate(-37.767 -835.296)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1131",
    "data-name": "Group 1131",
    transform: "translate(37.767 835.296)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_87",
    "data-name": "Rectangle 87",
    d: "M-1385.247,71.621h10.693c.176,0,.318.059.318.131v8.761c0,.072-.142.131-.318.131h-10.693c-.175,0-.317-.059-.317-.131V71.752C-1385.564,71.68-1385.422,71.621-1385.247,71.621Z",
    transform: "translate(1385.564 -59.141)",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_91",
    "data-name": "Rectangle 91",
    d: "M-1362.5,60.622h10.693a.288.288,0,0,1,.317.245V81.88a.288.288,0,0,1-.317.244H-1362.5a.288.288,0,0,1-.317-.244V60.867A.288.288,0,0,1-1362.5,60.622Z",
    transform: "translate(1375.955 -60.622)",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_762",
    "data-name": "Rectangle 762",
    width: 8.881,
    height: 4.169,
    rx: 0.549,
    transform: "translate(1.223 14.928)",
    fill: "#f2f2f2",
    stroke: "#707070",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_763",
    "data-name": "Rectangle 763",
    width: 8.835,
    height: 4.123,
    rx: 0.51,
    transform: "translate(1.246 14.952)",
    fill: "none",
    stroke: "#0f1325",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_87-2",
    "data-name": "Rectangle 87",
    d: "M-1339.38,71.621h10.693c.175,0,.317.059.317.131v8.761c0,.072-.142.131-.317.131h-10.693c-.175,0-.317-.059-.317-.131V71.752C-1339.7,71.68-1339.555,71.621-1339.38,71.621Z",
    transform: "translate(1366.19 -65.716)",
    fill: "#a6a6a6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_764",
    "data-name": "Rectangle 764",
    width: 8.881,
    height: 4.169,
    rx: 0.549,
    transform: "translate(27.717 8.355)",
    fill: "#f2f2f2",
    stroke: "#707070",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_765",
    "data-name": "Rectangle 765",
    width: 8.835,
    height: 4.123,
    rx: 0.51,
    transform: "translate(27.739 8.379)",
    fill: "none",
    stroke: "#0f1325",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_766",
    "data-name": "Rectangle 766",
    width: 8.881,
    height: 4.169,
    rx: 0.549,
    transform: "translate(14.363 14.928)",
    fill: "#f2f2f2",
    stroke: "#707070",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_767",
    "data-name": "Rectangle 767",
    width: 8.835,
    height: 4.123,
    rx: 0.51,
    transform: "translate(14.386 14.952)",
    fill: "none",
    stroke: "#0f1325",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_768",
    "data-name": "Rectangle 768",
    width: 8.881,
    height: 4.169,
    rx: 0.549,
    transform: "translate(14.363 8.496)",
    fill: "#f2f2f2",
    stroke: "#707070",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_769",
    "data-name": "Rectangle 769",
    width: 8.835,
    height: 4.123,
    rx: 0.51,
    transform: "translate(14.386 8.516)",
    fill: "none",
    stroke: "#0f1325",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_768-2",
    "data-name": "Rectangle 768",
    width: 8.881,
    height: 4.169,
    rx: 0.549,
    transform: "translate(14.363 1.965)",
    fill: "#f2f2f2",
    stroke: "#707070",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_769-2",
    "data-name": "Rectangle 769",
    width: 8.835,
    height: 4.123,
    rx: 0.51,
    transform: "translate(14.386 1.989)",
    fill: "none",
    stroke: "#0f1325",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50-7",
    "data-name": "Path 50-7",
    d: "M-1368.048,79.469h3.9",
    transform: "translate(1378.166 -62.455)",
    fill: "none",
    stroke: "#0f1325",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51-7",
    "data-name": "Path 51-7",
    d: "M-1361.739,79l.251.271-.251.271",
    transform: "translate(1375.501 -62.256)",
    fill: "none",
    stroke: "#0f1325",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50-7-2",
    "data-name": "Path 50-7",
    d: "M-1345.094,79.513h3.48",
    transform: "translate(1368.99 -69.049)",
    fill: "none",
    stroke: "#0f1325",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51-7-2",
    "data-name": "Path 51-7",
    d: "M-1338.616,79.044l.258.271-.258.271",
    transform: "translate(1365.734 -68.851)",
    fill: "none",
    stroke: "#0f1325",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51-7-3",
    "data-name": "Path 51-7",
    d: "M-1344.5,79.586l-.245-.271.245-.271",
    transform: "translate(1368.318 -68.851)",
    fill: "none",
    stroke: "#0f1325",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50-10",
    "data-name": "Path 50-10",
    d: "M-1353.063,71.939v1.777",
    transform: "translate(1371.836 -59.275)",
    fill: "none",
    stroke: "#0f1325",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50-10-2",
    "data-name": "Path 50-10",
    d: "M-1353.063,71.939v1.819",
    transform: "translate(1371.836 -65.709)",
    fill: "none",
    stroke: "#0f1325",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51-10",
    "data-name": "Path 51-10",
    d: "M-1352.99,74.886l-.271.237-.271-.237",
    transform: "translate(1372.034 -60.564)",
    fill: "none",
    stroke: "#0f1325",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51-10-2",
    "data-name": "Path 51-10",
    d: "M-1352.99,74.886l-.271.237-.271-.237",
    transform: "translate(1372.034 -66.956)",
    fill: "none",
    stroke: "#0f1325",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCanvasPlan);
export default __webpack_public_path__ + "static/media/canvas-plan.93b91e44380db4f055277cc91b2bb118.svg";
export { ForwardRef as ReactComponent };